import type { AuthUser } from '../contexts/AuthContext';

/**
 * Shared auth constants and utilities.
 * Allows API layer to trigger logout on 401 without importing AuthContext.
 */
export const TOKEN_KEY = 'pnid_auth_token';

let onUnauthorized: (() => void) | null = null;

export function setOnUnauthorized(cb: () => void): void {
  onUnauthorized = cb;
}

export function triggerUnauthorized(): void {
  onUnauthorized?.();
}

/**
 * Whether the user may mark an item as reviewed: the review or the admin
 * permission, the same rule the backend's review route and its reviewed-status
 * guard apply.
 */
export function canReviewUser(user: AuthUser | null): boolean {
  return Boolean(user?.permissions?.can_review || user?.permissions?.can_admin);
}

/**
 * Whether the user may edit a drawing's marks: the edit permission, or, for a user
 * whose permissions name no edit flag, anyone who is not a legacy reviewer.
 */
export function canEditUser(user: AuthUser | null): boolean {
  return user?.permissions?.can_edit ?? !user?.is_reviewer;
}
